import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService, DateUtils } from 'ng-jhipster';


import { ITEMS_PER_PAGE, Principal, CRUD_ACTIONS, DateUtilities } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { Event } from './event.model';
import { EventService } from './event.service';
import { EventUtilService } from './event.util.service';

@Component({
    selector: 'jhi-event',
    templateUrl: './event.component.html'
})
export class EventComponent implements  OnInit, OnDestroy {

    routeData: any;
    links: any;
    totalItems: any;
    maxHighlightedItems: any;
    currentEventSearch: any;
    queryCount: any;
    itemsPerPage: any;
    predicate: any;
    previousPage: any;
    page: any;
    reverse: any;
    highlightedevents: Event[];
    events: Event[];
    hasEventAdminRights: boolean = false;
    maxTitleSize: number = 30;

    eventListModificationSubscription: Subscription;

    private showMore: boolean;
    constructor(
        private eventManager: EventManager,
        private alertService: AlertService,
        private dateUtils: DateUtils,
        private parseLinks: ParseLinks,
        private paginationUtil: PaginationUtil,
        private languageService: JhiLanguageService,
        private paginationConfig: PaginationConfig,
        private activatedRoute: ActivatedRoute,
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private router: Router,
        private route: ActivatedRoute,
        private eventService: EventService,
        private eventUtilService: EventUtilService
    ) {
        this.itemsPerPage = 6;
        this.paginationConfig.setPageSize(this.itemsPerPage);

        this.maxHighlightedItems = 3;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });

        this.currentEventSearch = activatedRoute.snapshot.params['search']
            ? activatedRoute.snapshot.params['search']
            : '';

        this.jhiLanguageService.setLocations(['event', 'eventStatus', 'eventCategory']);
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.principal
            .hasAnyAuthority(['ROLE_SCHOOL_ADMIN'])
            .then((response) => {
                this.hasEventAdminRights = response;
                this.loadHighlightedEvents();
            });
        });
        this.registerChangeInEventList();
    }

    loadHighlightedEvents() {
        const query = this.hasEventAdminRights ? 'highlighted:true AND status:*' :
                                                 'highlighted:true AND NOT status:DRAFT';

        this.eventService.search({
            query,
            page: this.page - 1,
            size: this.maxHighlightedItems,
            sort: 'begining,asc'
        }).subscribe(
            (res: HttpResponse<Event[]>) => {
                this.onHighlightedEventsSuccess(res.body, res.headers);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    loadEvents() {
        this.currentEventSearch = this.hasEventAdminRights ? 'status:*' : 'NOT status:DRAFT' ;

        this.eventService.search({
            query: this.currentEventSearch,
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(
            (res: HttpResponse<Event[]>) => {
                this.onEventsSuccess(res.body, res.headers);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        return result;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['/event'], {
            queryParams:
            {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentEventSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadEvents();
    }

    ngOnDestroy() {
        this.eventListModificationSubscription.unsubscribe();
    }

    registerChangeInEventList() {
        this.eventListModificationSubscription = this.eventManager
                                                     .subscribe('eventListModification',
                                                        (response) => {
                                                            this.handleActionResult(response.content);
                                                        });
    }

    private handleActionResult(result: { action: string, content: any }) {
        let entity: any = result.content;
        let action: String = result.action;
        let foundInEvents = false;

        // we force the highlighted events to be loaded because a new highlighted event can be included
        // in the list because another was unhighlighted
        this.loadHighlightedEvents();

        if (!this.events) {
            return;
        }


        this.events.forEach((item, i) => {
            if (item.id === entity.id) {
                foundInEvents = true;
                switch (action) {
                    case CRUD_ACTIONS.UPDATE:
                        // we have to format the event before swaping
                        entity.begining = this.dateUtils
                                        .convertDateTimeFromServer(entity.begining);
                        entity.ending = this.dateUtils
                                        .convertDateTimeFromServer(entity.ending);
                        this.events[i] = entity;
                        break;
                    case CRUD_ACTIONS.DELETE:
                        this.events.splice(i, 1);
                        break;
                }
            }
        });

        if (action === CRUD_ACTIONS.CREATE || action === CRUD_ACTIONS.UPDATE) {
            entity.begining = this.dateUtils.convertDateTimeFromServer(entity.begining);
            entity.ending = this.dateUtils.convertDateTimeFromServer(entity.ending);

            if (!foundInEvents) {
                this.events.push(entity);
            }
        }
    }

    private onHighlightedEventsSuccess(data, headers) {
        this.highlightedevents = data;
    }

    private onEventsSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.events = data;
    }

    private onError(error: HttpErrorResponse, lessonId?: any) {
        this.alertService.error(error.error, null, null);
    }

    toggleShowMore() {
        this.showMore = !this.showMore;

        if (this.showMore) {
            this.loadEvents();
        }
    }

    getStatusBadgeClass(status: string): string {
        return this.eventUtilService.getStatusBadgeClass(status);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event.component.ts